import { Type } from 'class-transformer';

export class Entity {
    name: string;
    entity_type: string;
    relationship_type: string;
    relationship_type_id: number;
    spatial: boolean;
    feature?: string;
    hasDate?: boolean;

    constructor(name:string = '', entity_type:string = '', relationship_type:string = '', relationship_type_id:number = 0, spatial:boolean = false, feature?:string, hasDate?:boolean) {
        this.name = name;
        this.entity_type = entity_type;
        this.relationship_type = relationship_type;
        this.relationship_type_id = relationship_type_id;
        this.spatial = spatial;
        this.feature = feature;
        this.hasDate = hasDate;
    }
}

export class Property {
    id: number;
    name: string;
    property: string;
    type: string;
    stats: string[];
    min?: number;
    max?: number;
    hasDate?: boolean;

    constructor() {
        this.name = '';
        this.property = '';
        this.type = '';
        this.stats = [];
        this.id = 0;
        this.min = undefined;
        this.max = undefined;
        this.hasDate = this.hasDate;
    }
}

export class Definition extends Entity {
    @Type(() => Entity)
    entity: Entity[];

    @Type(() => Property)
    property: Property[];

    id?: number;

    constructor() {
        super();
        this.entity = [];
        this.property = [];
    }

    getPropertiesOfType(types: string[]) {
        return this.property.filter((item: Property) => {
            return types.includes(item.type);
        });
    }
}